
import "./Stepper.css";

const Stepper = ({ steps, currentStep,onTabClick  }) => {

  return (
    <div className="bs-stepper-header mb-5" role="tablist">
      {steps.map((step, idx) => (
        <div
          className={`step ${
            currentStep === idx + 1
              ? " active"
              : idx + 1 < currentStep
              ? "completed"
              : ""
          }`}  key={idx}
        >
          <button  onClick={() => onTabClick && onTabClick(idx + 1)}  type="button" className="step-trigger" role="tab">
            <span className="bs-stepper-label">{step}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
